import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nb from "./locales/nb.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import pl from "./locales/pl.json";
import sv from "./locales/sv.json";
import fi from "./locales/fi.json";
import is from "./locales/is.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nb: { translation: nb },
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      sv: { translation: sv },
      fi: { translation: fi },
      is: { translation: is },
    },
    fallbackLng: "en",
    supportedLngs: ["nb", "en", "de", "pl", "sv", "fi", "is"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
